import pkg from '../package.json'

export const state = () => {
  return {
    historys: [],
    uuid: '',
    turingKey: '',
    version: pkg.version
  }
}

// export const actions = {
//   async fetchIMUrl({ commit }) {
//     const info = await this.$api.querySnsByArea()
//     console.log(info, 'awaitdadad')
//     commit('SET_IMUrl', info)
//   }
// }

export const mutations = {
  addHistory(state, text) {
    if (state.historys.includes(text)) {
      return false
    }
    state.historys.push(text)
  },
  clearHistory(state) {
    state.historys = []
  },
  SET_UUID(state, uuid) {
    state.uuid = uuid
  },
  SET_TURING(state, turingKey) {
    state.turingKey = turingKey
  }
}
